import { LuPlus } from 'react-icons/lu';
import { ChangePlanModal } from '@/features/subscriptions/components/ChangePlanModal';
import { EmptyStateLayout } from './EmptyStateLayout';
import { useEmptyStateActions } from '../hooks/useEmptyStateActions';
import { StanIcon } from '@/components/core-components/types';
import { BUTTON_LABELS, BUTTON_NAMES, EMPTY_STATE_CONTENT, ROUTES } from '../constants';

import FlowEmptyImage from '@/assets/images/flow-empty.svg';

interface FlowEmptyStateProps {
    variant: 'upgrade' | 'add-flow';
    icon?: StanIcon;
}

/**
 * Empty state for the Flows tab
 * Shows different content based on whether user has email-flows module access
 * Matches Vue implementation: vue/src/pages/flows/components/onboarding/FlowEmptyState.vue
 */
export const FlowEmptyState = ({ variant, icon }: FlowEmptyStateProps) => {
    const isUpgradeVariant = variant === 'upgrade';
    const { handleButtonClick, isModalOpen, setIsModalOpen } = useEmptyStateActions({
        variant: isUpgradeVariant ? 'upgrade' : 'action',
        actionRoute: ROUTES.NEW_FLOW,
    });

    const buttonName = BUTTON_NAMES.FLOW_EMPTY_STATE;
    const buttonLabel = isUpgradeVariant ? BUTTON_LABELS.UPGRADE_TO_PRO : BUTTON_LABELS.ADD_FLOW;
    const buttonIcon = isUpgradeVariant ? <LuPlus /> : icon;

    const content = EMPTY_STATE_CONTENT.FLOWS;

    return (
        <>
            <EmptyStateLayout
                title={content.title}
                description={content.description}
                bulletPoints={content.bulletPoints}
                buttonText={buttonLabel}
                buttonIcon={buttonIcon}
                buttonName={buttonName}
                onButtonClick={handleButtonClick}
                illustration={FlowEmptyImage}
                imageAlt='Email Flow illustration'
            />

            {/* Change Plan Modal */}
            <ChangePlanModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
        </>
    );
};
